import { Injectable } from '@angular/core';
import { Api } from 'datatables.net';
@Injectable({
  providedIn: 'root'
})
export class MenuUnidadService {

  menuUnidad(datatableElement, etapa: any[], columna: number) {
    let cuenta = [];
    datatableElement.dtInstance.then((dtInstance: Api<any>) => {
      dtInstance.columns(columna).every(function () {
        const that = this;
        etapa.forEach(element => {
          that.search(element).page.info();
          cuenta.push(that.search(element).page.info().recordsDisplay);
        });
      });
    });
    return cuenta;
  }

}
